export const iconFontAwesomeGamingVrCardboard = (
	<i className="fa-solid fa-vr-cardboard"></i>
);
